// extracted by mini-css-extract-plugin
module.exports = {"container":"Consent-module--container--1L8of","content":"Consent-module--content--2l_Aa","btn":"Consent-module--btn--2CMk9","decline":"Consent-module--decline--28qmZ"};